<template>
    <div class="placeholder">
        <v-icon size="100">mdi-cloud-upload</v-icon>

        <div class="text">
           {{$t('message.campaigns.message.dropImageHere')}}
            <br>
            {{$t('message.campaigns.message.or')}}
        </div>

        <app-file-uploader data-location="INTERACTION"
                           :data-id="dataId"
                           :data-parent-id="dataParentId"></app-file-uploader>       
    </div>
</template>

<script>
    import AppFileUploader from '@components/FileUploader'
    // import _ from 'lodash'

    export default {
        components: {
            AppFileUploader,
        },

        data() {
            return {
                // defaultBackgroundColor: {
                //     a: 1,
                //     b: 255,
                //     g: 255,
                //     r: 255
                // }
            }
        },

        props: {
            dataId: {
                type: Number,
                required: true,
            },
            dataParentId: {
                type: Number,
                required: true,
            },
            dataInteraction: {
                type: Object,
                required: false
            },
        },

        computed: {
            // style() {
            //     const style = {}
            //     const item = this.dataInteraction
            //     _.forEach(item.estilo, (val, key) => {
            //         style[key] = val
            //     })

            //     return style
            // },
        },

        methods: {           
            
            // setBackgroundColor({color, attr}) {
            //     const style = _.cloneDeep(this.style)

            //     style[attr].color = color

            //     style["backgroundType"] = "COLOR"

            //     if(attr === "backgroundColorInteraction") {
            //         typeof color === "string" ? style[attr].isGradient = true : style[attr].isGradient = false            
            //     }
                
            //     const data = {
            //         estilo: style
            //     }

            //     this.$store.commit('SET_INTERACTION_DATA', {
            //         interactionId: this.dataInteraction.id,
            //         data
            //     })
            //     this.setTimeout({
            //         interaction: this.dataInteraction,
            //         data
            //     })
            // },
            // setTimeout({interaction, data}) {
            //     if (this.timeout)
            //         clearTimeout(this.timeout)

            //     this.timeout = setTimeout(() => this.commit({interaction, data}), 600)
            // },
            // commit({interaction, data}) {
            //     const payload = {
            //         advertisingId: interaction.campanhaId,
            //         interactionId: interaction.id,
            //         data,
            //     }                

            //     this.$api.interactions.update(payload)
            // },
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@variables';

    .placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        i {
            color: rgba($grey-5, .1);
        }

        .text {
            text-align: center;
            font-size: 12px;
            color: rgba($grey-5, .5);
            margin: 12px;
        }

        .btn {
            font-size: 12px;
        }
        .btn-background {
            font-size: 14px;
        }
    }
</style>
